import { createFileRoute } from "@tanstack/react-router";
import { fetchSharedChat } from "../../../features/ai-concierge/api/chat-share.api";
import { SharedChatPage } from "../../../features/ai-concierge/pages/shared-chat-page";

/**
 * `/{lang}/chat/{token}` — a conversation someone shared.
 *
 * Loaded on the server so the transcript is in the HTML for the person who
 * opens the link, and rendered `noindex,nofollow` because the token is a
 * secret. A missing or revoked token is not an error: the loader returns null
 * and the page says the link is no longer available.
 */
export const Route = createFileRoute("/$lang/_layout/chat/$token")({
  loader: ({ params }) => fetchSharedChat(params.token).catch(() => null),
  component: SharedChatRoute,
});

function SharedChatRoute() {
  const chat = Route.useLoaderData();
  const { token } = Route.useParams();
  return <SharedChatPage chat={chat} token={token} />;
}
